import { render, staticRenderFns } from "./BlockComponentSelector.vue?vue&type=template&id=4876ac3a"
import script from "./BlockComponentSelector.vue?vue&type=script&lang=js"
export * from "./BlockComponentSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports